<div class="container-fluid app-profile">

    <span class="subheader">USER MANAGEMENT</span>
    <h1>Profile Settings</h1>

    <mat-card class="card-style">

        <div class="row center-container">
            <div class="col-lg-12 mb-4">
                <h3 class="p-top-24">Default Market(s)</h3>
                <app-multi-dropbox popupPositionLeft="44" iconClass="material-icons dropbox-search-xl dropbox-search-xl-2" cssClassToApply="box-size" [(ngModel)]="defaultMarkets" placeholder="Select Your Market(s)" noEntriesFoundLabel="No market found" #marketMulti></app-multi-dropbox>

                <div class="chip-body" [hidden]="!(defaultMarkets?.length > 0)">
                    <div class="chip-content">
                        <div class="chip-item">
                            <mat-chip-list class="box-size">
                                <mat-chip color="primary" selected *ngFor="let market of defaultMarkets" [selectable]="selectable" (removed)="removeDefaultMarketFilter(market)">
                                    {{ market.name }}
                                    <mat-icon matChipRemove>cancel</mat-icon>
                                </mat-chip>
                            </mat-chip-list>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-12 mb-4">
                <h3>Default Timezone</h3>
                <mat-form-field class="box-size" appearance="standard">
                    <mat-select [(ngModel)]="selectedDefaultTimezoneType" name="defaultTimezoneTypeOptions">
                        <mat-option *ngFor="let timezoneType of defaultTimezoneTypeOptions" [value]="timezoneType">
                            {{timezoneType.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-lg-12 mb-4">
                <h3>Default Station Source</h3>
                <mat-form-field class="box-size" appearance="standard">
                    <mat-select [(ngModel)]="selectedDefaultStationSource" name="defaultStationSourceOptions" placeholder="Select Source">
                        <mat-option *ngFor="let stationSource of defaultStationSources" [value]="stationSource">
                            {{stationSource.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-lg-12 mb-4">
                <h3>Home Page Default Filter</h3>

                <app-multi-dropbox popupPositionLeft="44" [(ngModel)]="defaultHomeStationFilter" placeholder="Select Default Station Filter" iconClass="material-icons dropbox-search-xl dropbox-search-xl-3" cssClassToApply="box-size" [hideFilterButton]="true" [allowMultiple]="false"
                    noEntriesFoundLabel="No filter found" #defaultHomeFilterMulti [enableEdit]="true" (editIconClicked)="editDefaultHomeFilter($event)">
                </app-multi-dropbox>

                <div class="chip-body" [hidden]="!defaultHomeStationFilter">
                    <div class="chip-content">
                        <div class="chip-item">
                            <mat-chip-list class="box-size">
                                <mat-chip color="primary" selected [selectable]="selectable" (removed)="removeDefaultHomeFilter()">
                                    {{ defaultHomeStationFilter?.name }}
                                    <mat-icon matChipRemove>cancel</mat-icon>
                                </mat-chip>
                            </mat-chip-list>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-12 mb-4">
                <h3>Search Page Default Filter</h3>

                <app-multi-dropbox popupPositionLeft="44" [(ngModel)]="defaultSearchFilter" placeholder="Select Default Search Filter" iconClass="material-icons dropbox-search-xl dropbox-search-xl-3" cssClassToApply="box-size" [hideFilterButton]="true" [allowMultiple]="false"
                    noEntriesFoundLabel="No filter found" #defaultSearchFilterMulti [enableEdit]="true" (editIconClicked)="editDefaultSearchFilter($event)">
                </app-multi-dropbox>

                <div class="chip-body" [hidden]="!(defaultSearchFilter)">
                    <div class="chip-content">
                        <div class="chip-item">
                            <mat-chip-list class="box-size">
                                <mat-chip color="primary" selected [selectable]="selectable" (removed)="removeDefaultSearchFilter()">
                                    {{ defaultSearchFilter?.name }}
                                    <mat-icon matChipRemove>cancel</mat-icon>
                                </mat-chip>
                            </mat-chip-list>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </mat-card>

    <div>
        <button mat-button class="save-btn" [ngClass]="{ 'float-right': true, 'no-outline': true, 'primary-button': !disableSaveBtn }" [disabled]="disableSaveBtn" (click)="saveDefault();">{{ updateButtonText }}</button>
        <button mat-button class="float-right no-outline" (click)="resetFiltersWithDialog();">{{ cancelButtonText }}</button>
        <button mat-button class="float-right no-outline" [disabled]="disableClearButton" (click)="clearAll();">CLEAR</button>
    </div>

</div>